import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { Component, EventEmitter, Output, ViewChild, ComponentRef, OnInit } from '@angular/core';
import { AuthenticationService, UserService } from '../../_services';
import { Globals, Role } from '../../globals';
import { ChatService } from 'src/app/_services/chat.service';
import { ComponentPortal, CdkPortalOutlet, CdkPortalOutletAttachedRef } from '@angular/cdk/portal';
import { SearchInputComponent } from 'src/app/modules/search/components/search-input/search-input.component';
import { WebViewService } from 'src/app/_services/webview.service';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ImageWithPlaceholderComponent, FullSizedImageDirective } from '../../modules/shared/components/img-with-placeholder/img-with-placeholder.component';
import { NgOptimizedImage } from '@angular/common';
import { Angulartics2OnModule } from 'angulartics2';
import { MatBadge } from '@angular/material/badge';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { LanguageComponent } from '../../modules/shared/language/components/language.component';
import { AssetURLPipe } from '../../modules/shared/_pipes/assets-url.pipe';


@Component({
    selector: 'navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    imports: [MatToolbar, MatIconButton, MatIcon, RouterLink, ImageWithPlaceholderComponent, FullSizedImageDirective, NgOptimizedImage, CdkPortalOutlet, MatButton, Angulartics2OnModule, MatBadge, MatMenu, MatMenuItem, MatMenuTrigger, LanguageComponent, AssetURLPipe]
})
export class NavigationComponent implements OnInit {

  numberOfUnreadMessages: number;
  polling = false;
  userLoggedIn: boolean = false;
  
  searchPortal: ComponentPortal<SearchInputComponent> = new ComponentPortal(SearchInputComponent);

  @ViewChild(CdkPortalOutlet, {static: false}) searchPortalOutlet: CdkPortalOutlet;
  @Output() onMenuButtonClick: EventEmitter<void> = new EventEmitter();

  constructor(private router: Router,
              public route: ActivatedRoute,
              private userService: UserService,
              private authenticationService: AuthenticationService,
              private chatService: ChatService,
              private webViewService: WebViewService) {
    
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.init();
      }
    });
  }
  
  ngOnInit(): void {
    //this.userLoggedIn = this.userService.isLoggedIn();  
  }
  
  async init() {
    
    this.userLoggedIn = this.userService.isLoggedIn();
    
    if (!this.userLoggedIn) {
      return;
    }
    
    if (this.polling) {
      return;
    }
        
    const [unreadMessageCount] = await Promise.all([
      this.chatService.getNumberOfUnreadMessages()
    ]);
    
    this.numberOfUnreadMessages = unreadMessageCount;
    
    this.schedulePoll();
  }
  
  onSearchPortalAttached(ref: CdkPortalOutletAttachedRef | null) {
    if (ref instanceof ComponentRef) {
      ref.instance.onFiltersClicked.subscribe(() => {
        this.menuClicked();
      });
    }
  }
  
  private async schedulePoll(): Promise<void> {
    
    if (this.polling) {
      console.log("Already polling");
      return;
    }
    
    setTimeout(() => { this.poll() }, 10000);
    this.polling = true;
  }
  
  async poll(): Promise<void> {
    
    if (!this.userLoggedIn) {
      console.log("User not logged in, no point to poll");
      return;
    }
    
    console.log("Polling messages");
    await this.loadNumberOfUnreadMessages();
    
    console.log("Scheduling another poll");
    setTimeout(() => { this.poll() }, 10000);      
  }
  
  private async loadNumberOfUnreadMessages() {
    this.numberOfUnreadMessages = await this.chatService.getNumberOfUnreadMessages();
  }
  
  get IS_ADMIN(): boolean {
    const user = this.userService.getLoggedUser();
    
    if (!user) {
      return false;
    }
    
    return user.hasRole(Globals.ROLE_PREFIX + Role.ADMIN) || user.hasRole(Role.ADMIN);
  }
  
  get LOGGED_USER() {
    return this.userService.getLoggedUser();
  }
  
  async login() {
    if (!this.webViewService.detectWebView()) {
      this.authenticationService.login("/");
    }
  }

  logout() {
    this.authenticationService.logout();
  }
  
  async toChats() {
    this.router.navigate(["/chats"]);
  }
  
  toSnapAndSell() {
    this.router.navigate(["/snap-and-sell-v2"]);
  }
  
  async menuClicked() {
    this.onMenuButtonClick.emit();
  }
}
